import { Input, InputProps } from "@mui/material"
import { FocusEvent } from "react"

interface IProps extends InputProps {
  min?: number
  max?: number
  allowDecimal?: boolean // 添加是否允许小数点的参数
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
}

export default function InputNum(props: IProps) {
  const { allowDecimal = false, min, max, ...rest } = props
  const allowNegative = min === undefined || min < 0

  const getFilterRegex = () => {
    const chars = ["\\d"]
    if (allowNegative) chars.push("-")
    if (allowDecimal) chars.push(".")
    return new RegExp(`[^${chars.join("")}]`, "g")
  }

  const getKeyPattern = () => {
    const chars = ["\\d"]
    if (allowNegative) chars.push("-")
    if (allowDecimal) chars.push(".")
    return new RegExp(`[${chars.join("")}]`)
  }

  const isValidNumber = (value: string) => {
    return value && value !== "-" && value !== "." && !isNaN(Number(value))
  }

  const isNumber = (value: any): boolean => {
    return (
      typeof value === "number" ||
      (value !== null &&
        typeof value === "object" &&
        Object.prototype.toString.call(value) === "[object Number]")
    )
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    props.onBlur?.(e)
  }

  return (
    <Input
      {...rest}
      className={`base-input-style ${props.className || ""}`}
      // inputProps={{
      //   className: `base-input-style ${props.className || ""}`,
      // }}
      type="text"
      onInput={(e) => {
        const target = e.target as HTMLInputElement
        let value = target.value.replace(getFilterRegex(), "")

        if (isValidNumber(value)) {
          const numValue = Number(value)
          if (
            (isNumber(max) && numValue > max) ||
            (isNumber(min) && numValue < min)
          ) {
            value = target.value.slice(0, -1)
          }
        }

        target.value = value
      }}
      onKeyPress={(e) => {
        if (!getKeyPattern().test(String.fromCharCode(e.charCode))) {
          e.preventDefault()
        }
      }}
      onPaste={(e) => {
        setTimeout(() => {
          const target = e.target as HTMLInputElement
          target.value = target.value.replace(getFilterRegex(), "")
        }, 0)
      }}
      onChange={(e) => {
        const value = e.target.value
        if (!value || isValidNumber(value)) {
          props.onChange?.(e)
        } else {
          props.onChange?.({ ...e, target: { ...e.target, value: "" } } as any)
        }
      }}
      onBlur={handleBlur}
    />
  )
}
